<template>
  <div>
    <el-dialog  top="5vh" class="dialog-style" title="选择活动SKU" :visible.sync="dialogVisible" @before-close="handleBeforeClose" width="60%" >
      <div class="search-box">
        <el-input v-model="queryParams.brandName" placeholder="品牌名称" size="small" clearable/>
        <el-input v-model="queryParams.brandCode" placeholder="品牌编码" size="small" clearable/>
        <el-input v-model="queryParams.subBrandName" placeholder="子品牌名称" size="small" clearable/>
        <el-input v-model="queryParams.subBrandCode" placeholder="子品牌编码" size="small" clearable/>
        <el-input v-model="queryParams.skuName" placeholder="SKU名称" size="small" clearable/>
        <el-input v-model="queryParams.skuCode" placeholder="SKU编码" size="small" clearable/>
          <el-button type="danger" size="small" @click="getGameplanThemeThemeSkuList()">搜索</el-button>
          <el-button type="info" size="small" @click="resetForm()">重置</el-button>
      </div>
      <el-table :data="skuList" ref="skuTableRef" @select="select" @select-all="selectAll" :header-cell-style="{background:'#E8E8E8',color:'#4d4d4d'}" @selection-change="handleSelectionChange"
        :row-key="getRowKeys" >
        <el-table-column width="55" type="selection" reserve-selection></el-table-column>
        <el-table-column width="100" label="SKU编码" prop="skuCode" align="center" />
        <el-table-column label="SKU名称" prop="skuName" align="center" />
      </el-table>
      <div class="pagination">
        <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
          :page-size="queryParams.pageSize" @current-change="handleCurrentChange" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="redFont" @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="handleSelectSku()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import gameplanApi from "@/api/gameplan";
export default {
  data() {
    return {
      dialogVisible:false,
      loading:false,
      queryParams:{
        page: 1,
        pageSize: 10,
        skuName:'',
        skuCode:'',
        prNumber:'',
        brandName:'',
        brandCode:'',
        subBrandName:'',
        subBrandCode:'',
        skuSource:'SAP',
        isAbiOwn:'1'
      },
      total:0,
      selectedSkuList:[],
      btmpBrandDTOList:[],
      PRInfo:{},
      multipleSelection:[],
      skuList:[],
      selectList:[],
      curSkuList:[]
    };
  },
  created() {
    if(this.prNumber){
      this.queryParams.prNumber = this.prNumber
    }
  },
  props:{
    prNumber:{type:String,default:''},
    skuScope:{type:String,default:''},
    selectedSku:{ type: Array, default: () => [] },
  },
  watch: {
    skuList:{
      handler:function(){
          this.skuList.forEach(item=>{
            this.selectedSku.forEach(selectedItem=>{
              if(selectedItem.skuCode===item.skuCode){
                this.$refs.skuTableRef.toggleRowSelection(item,true)
              }
            })
          })
      },
      immediate:true
      //deep:true
    },
  },
  methods: {
    handleDataChange(){
        this.skuList.forEach(item=>{
          let isSelected = false
          this.selectedSku.forEach(selectedItem=>{
            if(selectedItem.skuCode===item.skuCode){
              isSelected = true
            }
          })
          this.$refs.skuTableRef.toggleRowSelection(item,isSelected)
        })
    },
    select(selection,row){
      let isSelected = false
      this.curSkuList.forEach((item,i)=>{
        if(item.skuCode===row.skuCode) isSelected = true
      })
      if(isSelected){
        let index = -1
        this.curSkuList.forEach((item,i)=>{
          if(item.skuCode===row.skuCode) index = i
        })
        if(index!==-1) this.curSkuList.splice(index,1)
      } else {
        let index = -1
        this.curSkuList.forEach((item,i)=>{
          if(item.skuCode===row.skuCode) index = i
        })
        if(index===-1) this.curSkuList.push(row)
      }
    },
    selectAll(selection){
      if(selection.length>0){
        this.skuList.forEach(item=>{
          this.select([item],item)
        })
      }else {
        this.skuList.forEach(sku=>{
          let index = -1
          this.curSkuList.forEach((item,i)=>{
            if(item.skuCode===sku.skuCode) index = i
          })
          if(index!==-1) this.curSkuList.splice(index,1)
        })
      }
    },
    show(){
      this.dialogVisible = true
      this.queryParams = this.$options.data().queryParams
      this.curSkuList = Object.assign([],this.selectedSku) 
    },
    handleBeforeClose(){
    },
    async getGameplanThemeThemeSkuList(){
      this.loading = true
      const { data } = await gameplanApi.getGameplanThemeThemeSkuList(this.queryParams);
      if (data.resultCode === "0") {
        this.skuList = data.resultData?.skuList || [];
        this.total = data.resultData.pageInfo.totalCounts
        await this.$nextTick(()=>{
          this.handleDataChange()
        });
      }
      this.loading = false
    },
    resetForm() {
      this.queryParams = this.$options.data().queryParams
      this.queryParams.prNumber = this.prNumber
      this.getGameplanThemeThemeSkuList()
    },
    handleSelectSku(){
      const skuScope = this.curSkuList.map(item=>{
        return item.skuCode
      })
      const skuName = this.curSkuList.map(item=>{
        return item.skuName
      })
      const skuList = this.curSkuList.map(item=>{
        const skuItem = {
          skuName:item.skuName,
          skuCode:item.skuCode
        }
        return skuItem
      })
      const data = {
        skuScope,
        skuName
      }
      this.$emit('handleSelectSku',skuList)
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeThemeSkuList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getRowKeys(row){
      return row.skuCode
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox{
  height: auto !important;
}
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 60vh;
}
::v-deep .el-input{
  width: 150px;
  margin: 0 10px 10px 0;
}
// ::v-deep .el-checkbox__input.is-checked:hover .el-checkbox__inner:hover,.el-checkbox__input.is-checked .el-checkbox__inner{
//   background-color: #C8102D !important;
//   border-color: #C8102D !important;
// }
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #C8102D !important;
  border-color: #C8102D !important;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #C8102D !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #C8102D !important;
}
.dialog-style{
  .search-box{
    margin-bottom: 20px;
  }
}
.pagination .el-pagination {
  margin-top: 10px;
  text-align: center;
}
</style>
